import React, { useState } from 'react';
import SanitizedHtml from 'src/components/ui/SafeHtml/SanitizedHtml';
import { useTranslation } from 'react-i18next';
import Modal from '../../layouts/Modal/Modal';
import Button, { ButtonToneProps } from '../../ui/Button/Button';
import Checkbox from '../../ui/Checkbox/Checkbox';
import { useCarrierTermsQuery } from '../../../services/carrier';
import styles from './TermsModal.module.scss';

export type TermsModalProps = {
  isOpen: boolean;
  onClose: (confirmed: boolean) => void;
  readOnly?: boolean;
};

const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onClose, readOnly }) => {
  const { t } = useTranslation();
  const [isTermsConfirmed, setIsTermsConfirmed] = useState(false);
  const { data, isLoading } = useCarrierTermsQuery();

  return (
    <Modal isOpen={isOpen} onClose={() => onClose(false)}>
      <div className="max-w-[640px] w-full flex flex-col h-[80vh] overflow-hidden">
        <div className="border-subtle-bottom py-[22px] sticky top-0 z-10">
          <div className="flex w-full justify-center">
            <h4 className="typo-text-16--bold">{data?.title || t('carrier_analytics.terms_of_usage')}</h4>
          </div>
        </div>

        <div className="border-subtle-bottom p-32 flex flex-col gap-[24px] flex-1 overflow-y-auto">
          {isLoading ? (
            <p>Loading...</p>
          ) : (
            <SanitizedHtml className={styles['terms-content']} html={data?.content || ''} />
          )}
        </div>

        {!readOnly && (
          <div className="py-16 px-24 flex justify-between sticky bottom-0 z-10">
            <div className="flex items-center gap-6">
              <Checkbox onChange={() => setIsTermsConfirmed(!isTermsConfirmed)} checked={isTermsConfirmed} />
              <span className="typo-text-14--medium">{t('carrier_analytics.terms_agree')}</span>
            </div>
            <Button
              disabled={!isTermsConfirmed}
              onClick={() => onClose(true)}
              tone={ButtonToneProps.PRIMARY_BLUE}
              title={t('general.confirm')}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default TermsModal;
